// linkedin and github links
export default function Footer() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light justify-content-center">
      <div className="m-2">
        <a href="https://www.linkedin.com/in/mathew-lundin/"><img src={process.env.PUBLIC_URL + "/images/LinkedIn_icon_circle.svg"} alt="LinkedIn"></img></a>
      </div>
      <div className="m-2">
        <a href="https://github.com/mat-lundin"><img src={process.env.PUBLIC_URL + "/images/Octicons-mark-github.svg.png"} alt="Github"></img></a>
      </div>
    </nav>
  )
}